import { Agent, AgentType } from "@models/agent";

export interface IBreadCrumb {
  label: string;
  url: string;
}

export class ApiKeyConfig {
  name: string;
  docs: string;
  description: string;
  serviceTypes: string[];
  isUpdating: boolean;
  passHidden: boolean;
}

export interface AudioPlayerState {
  audio: HTMLAudioElement;
  isPlaying: boolean;
  isLoading: boolean;
  progress: number;
  currentTime: number;
  duration: number;
}

/** Agent Template service specific contracts */
export class AgentTemplate {
  type: AgentType;

  /** TODO: Will be used in the future for passing predefined set of templates */
  preset?: any;
}


export interface FormStep {
  id: string;
  label: string;
  isValid: boolean;
  isCompleted: boolean;
  data?: any;
  route?: string;
  routeType: RouteType;
}


export enum RouteType {
  Configuration = 'Configuration',
  Overview = 'Overview'
}

export interface AgentFormState {
  currentStep: number;
  currentStepLabel?: string;
  steps: FormStep[];
  agent: Partial<Agent>;
  isFormValid: boolean;
  isLoading: boolean;
  loadError?: string;
  isInitialized: boolean;
  easyMode?: boolean;
}


export class IframeEvent {
  type: string;
  data: any;
}

/** Widget chat system rows (join/leave banners, session/day labels in transcript). */
export enum ChatMessageKind {
  HumanJoined = 'human_joined',
  HumanLeft = 'human_left',
  HistoryDivider = 'history_divider',
  DayDivider = 'day_divider',
}

/** Contact profile + transcript thread list item kinds. */
export enum ConversationTranscriptItemType {
  SessionDivider = 'divider',
  DayDivider = 'dayDivider',
  Message = 'message',
  CallEndedDivider = 'callEndedDivider',
}